/* =====================================================================
   Bolden accessibility fixes (WAVE audit, October 2026)
   Small, self-contained patches. Nothing here changes how the site looks.
   ===================================================================== */
(function () {
  'use strict';

  /* 1. Elements marked role="button" (FAQ-style toggles, cart order note,
        slider arrows) respond to Enter and Space like real buttons. */
  document.addEventListener('keydown', function (event) {
    var el = event.target;
    if (!el || el.getAttribute('role') !== 'button') return;
    if (el.tagName === 'BUTTON' || el.tagName === 'A') return;
    if (event.key === 'Enter' || event.key === ' ' || event.key === 'Spacebar') {
      event.preventDefault();
      el.click();
    }
  });

  /* 2. Cart drawer. It slides off-screen when closed but stayed reachable by
        Tab, so keyboard users landed inside an invisible cart. While closed
        it is now inert; when it opens, focus moves into it, Escape closes it,
        and focus returns to whatever opened it. */
  function setUpCartDrawer() {
    var drawer = document.querySelector('.eam-cart-container');
    if (!drawer) return;

    var lastFocused = null;
    var isOpen = function () { return drawer.style.right === '0px'; };

    var applyState = function () {
      if (isOpen()) {
        drawer.removeAttribute('inert');
        drawer.removeAttribute('aria-hidden');
        var closeBtn = drawer.querySelector('.eam-cart-close');
        if (closeBtn && !drawer.contains(document.activeElement)) closeBtn.focus();
      } else {
        drawer.setAttribute('inert', '');
        drawer.setAttribute('aria-hidden', 'true');
        if (lastFocused && document.body.contains(lastFocused)) lastFocused.focus();
        lastFocused = null;
      }
    };

    document.addEventListener('focusin', function (event) {
      if (!isOpen() && !drawer.contains(event.target)) lastFocused = event.target;
    });

    new MutationObserver(applyState).observe(drawer, { attributes: true, attributeFilter: ['style'] });
    applyState();

    document.addEventListener('keydown', function (event) {
      if (event.key !== 'Escape' || !isOpen()) return;
      var closeBtn = drawer.querySelector('.eam-cart-close');
      if (closeBtn) closeBtn.click();
    });
  }

  /* 3. Klaviyo newsletter form. The email field is injected by Klaviyo with
        a placeholder but no label. Until the label is set in Klaviyo's form
        editor, give any unlabeled field a name screen readers can read. */
  function labelKlaviyoFields(root) {
    var fields = (root || document).querySelectorAll(
      '[class*="klaviyo-form"] input:not([type="hidden"]):not([type="submit"]), [class*="klaviyo-form"] select, [class*="klaviyo-form"] textarea'
    );
    fields.forEach(function (field) {
      if (field.getAttribute('aria-label') || field.getAttribute('aria-labelledby')) return;
      if (field.id && document.querySelector('label[for="' + field.id + '"]')) return;
      if (field.closest('label')) return;
      var name = field.getAttribute('placeholder') ||
        (field.type === 'email' || /email/i.test(field.name || '') ? 'Email address' : '');
      if (name) field.setAttribute('aria-label', name);
    });
  }

  function watchKlaviyo() {
    labelKlaviyoFields();
    var forms = document.querySelectorAll('[class*="klaviyo-form"]');
    forms.forEach(function (form) {
      new MutationObserver(function () { labelKlaviyoFields(form); })
        .observe(form, { childList: true, subtree: true });
    });
  }

  /* 4. Slider library clean-up. The slideshow plugin adds aria-describedby /
        aria-controls pointing at navigation dots, even when a slider has only
        one slide and no dots are drawn. Remove any reference whose target is
        missing so screen readers aren't sent to nothing. */
  function removeBrokenAriaRefs() {
    ['aria-describedby', 'aria-labelledby', 'aria-controls'].forEach(function (attr) {
      document.querySelectorAll('[' + attr + ']').forEach(function (el) {
        var ids = (el.getAttribute(attr) || '').split(/\s+/).filter(Boolean);
        var valid = ids.filter(function (id) { return document.getElementById(id); });
        if (valid.length === ids.length) return;
        if (valid.length) el.setAttribute(attr, valid.join(' '));
        else el.removeAttribute(attr);
      });
    });
  }
  window.addEventListener('load', function () {
    removeBrokenAriaRefs();
    // Sliders can finish setting up slightly after load
    setTimeout(removeBrokenAriaRefs, 1500);
  });
  if (window.jQuery) {
    window.jQuery(document).on('init reInit', '.slick-slider', function () {
      setTimeout(removeBrokenAriaRefs, 0);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      setUpCartDrawer();
      watchKlaviyo();
    });
  } else {
    setUpCartDrawer();
    watchKlaviyo();
  }
})();
